export default __webpack_public_path__ + "static/media/hanskleinTeaser.1287909f.webm";